import { NgModule } from '@angular/core';
import { components } from './components';
import { pages } from './pages';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { LayoutModule } from '@angular/cdk/layout';
import { GpsCartCountBadgeModule } from '@geneplanet/ngx-shop/src/lib/cart-count-badge';
import { GptLocalizationModule } from '@geneplanet/ngx-utils/src/lib/localization';
import { GpuFormFieldModule } from '@geneplanet/ngx-ui/src/lib/form-field';
import { GpuLayoutModule } from '@geneplanet/ngx-ui/src/lib/layout';
import { LokaliseOverrideModule } from '../lokalise';
import { FeatureActivePipe } from '../shared/pipes/feature-active.pipe';

@NgModule({
  declarations: [...pages, ...components],
  imports: [
    CommonModule,
    TranslateModule,
    RouterModule,
    SharedModule,
    LayoutModule,
    GpuFormFieldModule,
    GpsCartCountBadgeModule,
    GptLocalizationModule,
    GpuLayoutModule,
    LokaliseOverrideModule,
    FeatureActivePipe,
  ],
  exports: [...pages, ...components],
})
export class CoreModule {}
